import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { BackButton } from './backButton';

export const HeaderLeftIcon = props => {
  let match = useRouteMatch({
    path: ['/', '/home', '/index.html', '', './'],
    strict: true,
    exact: true,
    sensitive: true
  });
  console.log(match);
  return <>{match ? null : <BackButton />}</>;
};
